<div
  class="radio-card"
  [class.radio-card--selected]="selected()"
  [class.radio-card--disabled]="disabled()"
  [attr.role]="mode() === 'radio' ? 'radio' : null"
  [attr.aria-checked]="mode() === 'radio' ? selected() : null"
  [attr.tabindex]="disabled() ? -1 : 0"
  (click)="onSelect()"
  (keydown.enter)="onSelect()"
  (keydown.space)="onSelect(); $event.preventDefault()">

  @if (mode() === 'radio') {
    <!-- Radio indicator -->
    <div class="radio-card__indicator">
      <div class="radio-card__radio">
        @if (selected()) {
          <div class="radio-card__radio-dot"></div>
        }
      </div>
    </div>
  }

  <!-- Content -->
  <div class="radio-card__content">
    <!-- Header avec icon/photo, title, badge -->
    <div class="radio-card__header">
      @if (article(); as art) {
        <!-- Article mode : photo ou fallback icon -->
        <div class="radio-card__article-photo"
             [class.cursor-pointer]="showPopover()"
             [popoverTrigger]="articlePopover"
             [popoverDisabled]="!showPopover()"
             [closeOnClickOutside]="true"
             (click)="showPopover() && $event.stopPropagation()">
          @if (art.photo) {
            <vl-doc-local [docId]="art.photo" width="40px" height="40px" [readOnly]="true"/>
          } @else {
            <mat-icon>inventory_2</mat-icon>
          }
        </div>
      } @else if (icon()) {
        <div class="radio-card__icon">
          <mat-icon>{{ icon() }}</mat-icon>
        </div>
      }

      <div class="radio-card__titles">
        <div class="radio-card__title-row">
          <span class="radio-card__title"
                [class.cursor-pointer]="showPopover()"
                [popoverTrigger]="articlePopover"
                [popoverDisabled]="!showPopover()"
                [closeOnClickOutside]="true"
                (click)="showPopover() && $event.stopPropagation()">
            @if (article()?.bio) {
              <vl-bio-logo/>
            }
            {{ resolvedTitle() }}
          </span>
          <ng-content select="[aide]"></ng-content>
        </div>
        @if (resolvedSubtitle()) {
          <span class="radio-card__subtitle">{{ resolvedSubtitle() }}</span>
        }
      </div>

      <div class="radio-card__badge">
        <ng-content select="[badge]"></ng-content>
      </div>
    </div>

    <!-- Contenu projeté -->
    <ng-content select="[content]"></ng-content>

    <!-- Footer projeté -->
    <ng-content select="[footer]"></ng-content>
  </div>
</div>

<!-- Article popover (same as article-small-card) -->
<ng-template #articlePopover let-close="close">
  @if (article(); as art) {
    <div class="border-8 up-4 container-background-reverse-alt p-12 flex-col gap-12 border-primary">
      <div class="flex-col w100">
        <div class="flex-row w100">
          <mat-icon class="ml-auto cursor-pointer" (click)="close?.()">close</mat-icon>
        </div>
        <div class="flex-col gap-4">
          <span class="on-background-reverse">
            @if (art.bio) {
              <vl-bio-logo/>
            }
            {{ art.denomination }}
          </span>
          <span class="on-background-reverse-alt body-2">{{ art.code }}</span>
        </div>
      </div>
      <div class="flex-row gap-12 justify-center">
        @if (art.withTraca) {
          <vl-chips state="warn" size="small" cursor="default">{{ 'article_badges.traca' | trans }}</vl-chips>
        }
        @if (art.withPiedDeChaine) {
          <vl-chips state="primary" size="small" cursor="default">{{ 'article_badges.pdc' | trans }}</vl-chips>
        }
        @if (art.withConsoTraca) {
          <vl-chips state="warn" size="small" cursor="default">{{ 'article_badges.consos' | trans }}</vl-chips>
        }
        @if (!art.withConsoTraca && !art.withPiedDeChaine) {
          <vl-chips state="secondary" size="small" cursor="default">{{ 'article_badges.auto' | trans }}</vl-chips>
        }
      </div>
      <vl-big-button (action)="onNavigate()" [text]="'article.goToArticle' | trans" icon="link" color="accent"/>
      <vl-big-button (action)="onStats()" [text]="'data.stats' | trans" icon="query_stats" color="accent"/>
      <vl-big-button (action)="goToComptage()" [text]="'lot.count' | trans" icon="123" color="accent"/>
      <vl-big-button (action)="onStock()" [text]="'data.lots' | trans" icon="package_2" color="accent"/>
    </div>
  }
</ng-template>
